// libs
import { styled } from '@nykaa/ui-components';

// base
import { HIDE_SCROLLBARS } from 'shared/styles/base';

export const Crumb = styled.a`
  ${({ theme }) => theme.typography.buttonSmall};
  ${({ theme }) => `color:${theme.colors.textSecondary};`};
  text-underline-offset: 3px;
  white-space: nowrap;
  text-decoration: none;
`;

export const BreadCrumbWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const ArrowWrapper = styled.span`
  ${({ theme }) => `margin: 0 ${theme.spacing.spacing20} 0 ${theme.spacing.spacing20}`};
`;

export const ProductTitle = styled.div`
  ${({ theme }) => theme.typography.bodySmall};
  ${({ theme }) => `color: ${theme.colors.textSecondary};`};
  white-space: nowrap;
`;

export const CrumbArrowWrapper = styled.div<{ stickyCrumb: boolean }>`
  background-color: ${({ theme }) => theme.colors.surface};
  display: flex;
  align-items: center;
  ${({ stickyCrumb }) => `${stickyCrumb && 'position: sticky; left:0;'}`};
`;

export const BreadCrumpParent = styled.div<{ isMobile: boolean }>`
  display: flex;
  overflow: scroll;
  ${HIDE_SCROLLBARS}
  ${({ theme, isMobile }) =>
    `margin: ${theme.spacing.spacing50} ${
      isMobile ? theme.spacing.spacing80 : theme.spacing.spacing50
    } ${theme.spacing.spacing50} ${isMobile ? theme.spacing.spacing80 : theme.spacing.spacing50}; 
    ${isMobile && `flex-direction: row-reverse;`}
  `};
`;
